import React, { useState, useEffect } from 'react';
import { Drawer, Box, Typography, IconButton, Button, Avatar } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import SelectAvatar from './SelectAvatar';
import UploadAvatar from './UploadAvatar';
import { useDispatch, useSelector } from 'react-redux';
import { fetchUser, updateUser } from '../../../store/Slices/userSlice';
import api from '../../../API/api';
import { ProfilePath } from '../../../API/config';

const AvatarSelectDrawer = ({ open, onClose }) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { data: user, loading } = useSelector((state) => state.user);
  const [avatars, setAvatars] = useState([]);
  const [selectedAvatar, setSelectedAvatar] = useState(null);
  const [isUpload, setIsUpload] = useState(false);
  const User = useSelector((state) => state.user.data);

  useEffect(() => {
    if (open) {
      const fetchAvatars = async () => {
        try {
          const response = await api.get('/profile-images');
          const imageUrls = response.data.map((file) => `${ProfilePath}/ProfileImages/${file}`);
          setAvatars(imageUrls);
        } catch (error) {
          console.error('Error fetching avatars:', error);
        }
      };

      fetchAvatars();
      if (user?.avatar) {
        setSelectedAvatar(user.avatar);
      }
    }
  }, [open, user]);

  const handleSaveAvatar = async () => {
    let avatarFile = selectedAvatar;

    // إذا كان selectedAvatar رابط صورة (URL)
    if (typeof selectedAvatar === 'string' && selectedAvatar.startsWith('http')) {
      const response = await fetch(selectedAvatar);
      const blob = await response.blob();
      avatarFile = new File([blob], 'profile_image', { type: blob.type });
    }
    
    // إذا كان selectedAvatar هو كائن File (صورة تم رفعها)
    else if (selectedAvatar instanceof File) {
      avatarFile = selectedAvatar;
    }

    if (avatarFile) {
      const userData = { ...user, profile_image: avatarFile };
      await dispatch(updateUser(userData));
      dispatch(fetchUser()); // تحديث بيانات المستخدم بعد التحديث
      onClose();
    }
  };

  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      sx={{
        '& .MuiDrawer-paper': {
          borderTopLeftRadius: 16,
          borderTopRightRadius: 16,
          padding: 3,
          height: '60vh',
        },
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>Change Picture</Typography>
        <IconButton onClick={onClose}><CloseIcon /></IconButton>
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
        <Avatar
          src={selectedAvatar == null ? User.profile_image ?`${ProfilePath}${User.profile_image}`:undefined : selectedAvatar}
          alt="Selected Avatar"
          sx={{ width: 100, height: 100, border: `3px solid ${theme.palette.brand.main}` }}
        />
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mb: 3 }}>
        <Button
          variant="text"
          sx={{ color: theme.palette.brand.main, textTransform: 'none', fontWeight: 'bold' }}
          onClick={() => setIsUpload(false)}
        >
          Select Avatar
        </Button>
        <Button
          variant="text"
          sx={{ color: theme.palette.brand.main, textTransform: 'none', fontWeight: 'bold' }}
          onClick={() => setIsUpload(true)}
        >
          Upload Image
        </Button>
      </Box>

      {isUpload ? (
        <UploadAvatar onSelectAvatar={setSelectedAvatar} />
      ) : (
        <SelectAvatar avatars={avatars} selectedAvatar={selectedAvatar} setSelectedAvatar={setSelectedAvatar} />
      )}

      <Box sx={{ p: 2, mt: 3 }}>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          sx={{
            bgcolor: theme.palette.brand.main,
            color: theme.palette.getContrastText(theme.palette.brand.main),
            fontWeight: 'bold',
            '&:hover': { bgcolor: theme.palette.brand.main },
          }}
          onClick={handleSaveAvatar}
          disabled={loading}
        >
          Save
        </Button>
      </Box>
    </Drawer>
  );
};

export default AvatarSelectDrawer;
